/**
 * One place for what the product is called and whose it is.
 *
 *   PRODUCT_NAME   — the product, the same for every institution.
 *   institution    — the institution this page belongs to: from the signed-in
 *                    user (the server sends it with the login), or before
 *                    sign-in from the page's own address (hooks/useSignInInstitution,
 *                    backend tenancy/host.js). Null = show the product alone.
 */
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME || 'Intelversity Exam';

export const institutionOfUser = (user) => (user && user.institution && user.institution.name ? user.institution : null);
